import React from 'react';
import {
  FaHome,
  FaBook,
  FaSearch,
  FaSignOutAlt,
  FaListUl,
  FaFileAlt,
  FaPenNib,
  FaChevronRight,
  FaTimes,
  FaUserCircle,
  FaEdit
} from 'react-icons/fa';
import { Link, withRouter } from 'react-router-dom';
import './cssfile/mockheader.css';

class Mockheader extends React.Component {
  constructor(props) {
    super(props);

    const isMobile = window.innerWidth < 992;

    this.state = {
      // Desktop: open
      // Mobile/tablet: closed until Menu is clicked
      showSidebar: !isMobile,
      isLoggedIn: !!(
        localStorage.getItem('email') &&
        localStorage.getItem('password')
      )
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth < 992;

    this.setState(prevState => {
      // When entering desktop, open sidebar.
      // When entering mobile, close it so Menu button is available.
      if (!isMobile) {
        return { showSidebar: true };
      }

      if (prevState.wasDesktop === true) {
        return {
          showSidebar: false,
          wasDesktop: false
        };
      }

      return {
        wasDesktop: false
      };
    });
  };

  toggleSidebar = () => {
    this.setState(prevState => ({
      showSidebar: !prevState.showSidebar
    }));
  };

  closeMobileSidebar = () => {
    if (window.innerWidth < 992) {
      this.setState({ showSidebar: false });
    }
  };

  handleLogout = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    localStorage.removeItem('regid');
    localStorage.removeItem('payment_regid');
    localStorage.removeItem('payment_exp');
    window.location.reload();
  };

  getCandidateName = () => {
    return (
      localStorage.getItem('name') ||
      localStorage.getItem('username') ||
      localStorage.getItem('candidate_name') ||
      'Candidate'
    );
  };

  getInitial = () => {
    const name = this.getCandidateName();
    return name.charAt(0).toUpperCase();
  };

  renderNavItem = (to, icon, label) => {
    const currentPath =
      this.props.location?.pathname || window.location.pathname;

    const active =
      currentPath === to ||
      (to !== '/home' && currentPath.startsWith(to));

    return (
      <li
        key={to}
        className={active ? 'mock-nav-item active' : 'mock-nav-item'}
      >
        <Link
          to={to}
          className="mock-nav-link"
          onClick={this.closeMobileSidebar}
        >
          <span className="mock-nav-icon">{icon}</span>
          <span className="mock-nav-label">{label}</span>
          <FaChevronRight className="mock-nav-arrow" />
        </Link>
      </li>
    );
  };

  render() {
    const { isLoggedIn, showSidebar } = this.state;
    const isMobile = window.innerWidth < 992;

    const candidateName = this.getCandidateName();
    const email = localStorage.getItem('email') || 'Guest user';

    return (
      <>
        {/* Mobile menu button is ALWAYS rendered on mobile */}
        {isMobile && (
          <button
            type="button"
            className="mock-mobile-toggle"
            onClick={this.toggleSidebar}
            aria-label="Open navigation menu"
          >
            <FaListUl aria-hidden="true" />
            <span>Menu</span>
          </button>
        )}

        {/* Mobile overlay */}
        {isMobile && showSidebar && (
          <button
            type="button"
            className="mock-sidebar-overlay"
            onClick={this.closeMobileSidebar}
            aria-label="Close navigation"
          />
        )}

        <aside
          className={`mock-sidebar ${
            showSidebar
              ? 'mock-sidebar-open'
              : 'mock-sidebar-closed'
          }`}
        >
          <div className="mock-sidebar-inner">

            <div className="mock-sidebar-brand">
              <div className="mock-brand-mark">E</div>

              <div className="mock-brand-copy">
                <strong>ErwaToday</strong>
                <span>Candidate Portal</span>
              </div>

              {isMobile && (
                <button
                  type="button"
                  className="mock-sidebar-close"
                  onClick={this.closeMobileSidebar}
                  aria-label="Close menu"
                >
                  <FaTimes />
                </button>
              )}
            </div>

            <div className="mock-candidate-card">
              <div className="mock-candidate-avatar">
                {isLoggedIn ? (
                  <span>{this.getInitial()}</span>
                ) : (
                  <FaUserCircle />
                )}
              </div>

              <div className="mock-candidate-info">
                <strong>{candidateName}</strong>
                <span>{email}</span>
              </div>

              {isLoggedIn && (
                <Link
                  to="/profile"
                  className="mock-profile-edit"
                  onClick={this.closeMobileSidebar}
                  title="Edit profile"
                  aria-label="Edit profile"
                >
                  <FaEdit />
                </Link>
              )}
            </div>

            <Link
              to="/profile"
              className="mock-profile-view"
              onClick={this.closeMobileSidebar}
            >
              <span>View / Edit Profile</span>
              <FaChevronRight />
            </Link>

            <div className="mock-menu-label">MAIN MENU</div>

            <nav className="mock-navigation" aria-label="Main navigation">
              <ul>
                {this.renderNavItem('/home', <FaHome />, 'Home')}
                {this.renderNavItem('/allseries', <FaBook />, 'Add Series')}
                {this.renderNavItem('/mcq_practice', <FaSearch />, 'MCQ Practice')}
                {this.renderNavItem('/question_paper_download', <FaFileAlt />, 'Question Papers')}
                {this.renderNavItem('/blog', <FaPenNib />, 'Publish Blog')}
                {this.renderNavItem('/question_paper', <FaFileAlt />, 'Question Paper PDF')}
              </ul>
            </nav>

            <div className="mock-sidebar-spacer" />

            <div className="mock-account-section">
              {isLoggedIn ? (
                <button
                  type="button"
                  className="mock-logout"
                  onClick={this.handleLogout}
                >
                  <FaSignOutAlt />
                  <span>Logout</span>
                </button>
              ) : (
                <Link
                  to="/login"
                  className="mock-login"
                  onClick={this.closeMobileSidebar}
                >
                  Sign In
                </Link>
              )}
            </div>

            <div className="mock-sidebar-footer">
              <span>© ErwaToday</span>
              <span>v2.0</span>
            </div>

          </div>
        </aside>
      </>
    );
  }
}

export default withRouter(Mockheader);
